export default __webpack_public_path__ + "static/message@2x-7eddccfd0498603dd6bde493751a5153.png";